import React from 'react';
import { Layout } from 'antd';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import SiderLayout from './MainLayout/SiderLayout';
import HeaderLayout from './MainLayout/HeaderLayout';
import GeneralOfferLayout from './MainLayout/ContentLayout/GeneralOfferLayout';
import SimpleFlightFormContainer from './MainLayout/ContentLayout/SimpleFlightLayout/SimpleFlightFormContainer';
import FlightPlusHotelFormContainer from './MainLayout/ContentLayout/FlightPlusHotelLayout/FlightPlusHotelFormContainer';
import RoundFlightFormContainer from './MainLayout/ContentLayout/RoundFlightLayout/RoundFlightFormContainer';
import DashboardLayout from './MainLayout/ContentLayout/DashboardLayout';
import HeroToolContainer from './MainLayout/ContentLayout/HeroToolLayout/HeroToolContainer';
import HotelPostContainer from './MainLayout/ContentLayout/HotelPostLayout/HotelPostContainer';
import './styles/MainLayout.less';

// Don't rage me: read this: https://github.com/ant-design/babel-plugin-import/issues/172
// eslint-disable-next-line prefer-destructuring
const Sider = Layout.Sider;
// eslint-disable-next-line prefer-destructuring
const Header = Layout.Header;
// eslint-disable-next-line prefer-destructuring
const Content = Layout.Content;

// MainLayout for Alcatraz, Sider, Header and Content
const MainLayout = ({ token }) => (
  <div>
    <Layout>
      <BrowserRouter>
        <Sider className="main-layout-sider">
          <SiderLayout />
        </Sider>
        <Layout>
          <Header className="main-layout-header">
            <HeaderLayout />
          </Header>
          <div className="main-layout-content">
            <Switch>
              <Route exact path="/">
                <Content className="dashboard-content">
                  <DashboardLayout />
                </Content>
              </Route>
              <Route path="/oferta-general/:id?">
                <Content className="general-offer-content">
                  <GeneralOfferLayout token={token} />
                </Content>
              </Route>
              <Route path="/vuelo-sencillo/:id?">
                <Content className="simple-trip-content">
                  <SimpleFlightFormContainer token={token} />
                </Content>
              </Route>
              <Route path="/vuelo-redondo/:id?">
                <Content className="round-trip-content">
                  <RoundFlightFormContainer token={token} />
                </Content>
              </Route>
              <Route path="/vuelo-mas-hotel/:id?">
                <Content className="flight-hotel-content">
                  <FlightPlusHotelFormContainer token={token} />
                </Content>
              </Route>
              <Route path="/oferta-hotel/:id?">
                <Content className="flight-hotel-content">
                  <HotelPostContainer token={token} />
                </Content>
              </Route>
              <Route path="/hero-tool">
                <Content className="notifications-content">
                  <HeroToolContainer token={token} />
                </Content>
              </Route>
              <Route path="/ajustes">
                <Content className="settings-content">
                  <h1>AJUSTES</h1>
                </Content>
              </Route>
            </Switch>
          </div>
        </Layout>
      </BrowserRouter>
    </Layout>
  </div>
);

MainLayout.propTypes = {
  token: PropTypes.string.isRequired,
};

export default MainLayout;
